import { View, Text, TouchableOpacity, ImageBackground, SafeAreaView, Dimensions, ScrollView, Image } from 'react-native'
import React from 'react'
import { useState, useEffect } from 'react';

export default function Activities() {

    let normalColor = '#d4d4d4';
    let pressedColor = '#e9e9e9';

           /* #################   O F F I C I A L   H E X   C O L O R S #################### */

           let ORANGE = '#FF6600';
           let LIGHTBLUE  = '#00B4FF';
           let DARKBLUE = '#393BB2';
           let YELLOW = '#fff605';
    
     
      let normalColorAirport = '#caa347';
      let pressedColorAirport = '#edddb8';
      let fullWidth = 800;
      let textColor = 'gray';
      let iconColor = 'white';
     
      let rowHeight = 45;
      let dateFlag = 0;
      let borderShade = 'gray';
    
      let fontSizeNormalMobile = 14;
      let fontSizeMediumMobile = 17;
      let fontSizeLargeMobile = 20;
      let fontSizeXSmallMobile = 13;
      let fontSizeNormalDesktop = 17;
      let fontSizeMediumDesktop = 20;
      let fontSizeLargeDesktop = 30;
    
      const [SID, setSID] = useState('');
      const [bookingID, setBookingID] = useState(''); 
      const [errorPrompt, setErrorPrompt] = useState('Please select Arrival and/or Departure dates to begin.');
      let today = new Date();
      let dateToday = today.getFullYear()+"-"+ parseInt(today.getMonth()+1) +"-"+today.getDate();
      let todayPlus24H = new Date(today.setHours(today.getHours() + 24))
      let dateTodayPlus24H = todayPlus24H.getFullYear()+"-"+ parseInt(todayPlus24H.getMonth()+1) +"-"+todayPlus24H.getDate();
      const [airportFlag, setAirportFlag] = useState(2); /* 2 = Caticlan, 1 = Kalibo */
      const [originID, setOriginID] = useState('2'); /* 2 = Caticlan, 1 = Kalibo */
      const [tx, setTx] = useState('');
      const [width, setWidth] = useState(Dimensions.get('window').width)
      const [height, setHeight] = useState(Dimensions.get('window').height);
      const [margin, setMargin] = useState(0);
      const [rowResponsive, setRowResponsive] = useState('row');
      const [scale, setScale] = useState(1);
      const [divider, setDivider] = useState(1);
      const [heightScale, setHeightScale] = useState(1);
      const [checkOutFlag, setCheckOutFlag] = useState(0);
     
      const [adonIndent, setAdonIndent] = useState(0);
  
    const [boxActivity0, setboxActivity0] = useState(normalColor)
    const [boxActivity1, setboxActivity1] = useState(normalColor)
    const [boxActivity2, setboxActivity2] = useState(normalColor)
    const [boxActivity3, setboxActivity3] = useState(normalColor)
    const [boxActivity4, setboxActivity4] = useState(normalColor)
    const [boxActivity5, setboxActivity5] = useState(normalColor)
    const [boxActivity6, setboxActivity6] = useState(normalColor)

    const ClickedActivites = (a, b, c, d, e, f, g) => {
        let borderThicknessCat = 3
        a == 1 ? setboxActivity0(pressedColor) : setboxActivity0(normalColor)
        b == 1 ? setboxActivity1(pressedColor) : setboxActivity1(normalColor)
        c == 1 ? setboxActivity2(pressedColor) : setboxActivity2(normalColor)
        d == 1 ? setboxActivity3(pressedColor) : setboxActivity3(normalColor)
        e == 1 ? setboxActivity4(pressedColor) : setboxActivity4(normalColor)
        f == 1 ? setboxActivity5(pressedColor) : setboxActivity5(normalColor)
        g == 1 ? setboxActivity6(pressedColor) : setboxActivity6(normalColor)
      }


  const [dimension, setDimension] = useState(
    {
        winwidth :window.innerWidth,
        winheight : window.innerHeight,
    }
)

const updateDimension = () => {
    setDimension(
        {
            winwidth :window.innerWidth,
            winheight : window.innerHeight,
        }
    )
    setWidth(dimension.winwidth);
    setHeight(dimension.winheight);
}

useEffect(() => {
    //console.log('resize')
    window.addEventListener('resize', updateDimension)
    if (dimension.winwidth <= 450){
        
        setRowResponsive('column');
        setWidth(400);
        setScale(1);
        setHeightScale(.5)
        setAdonIndent(5)
    } else {
        setMargin(0)
        setRowResponsive('row')
        setWidth(fullWidth)
        setScale(2.1)
        setHeightScale(1)
        setAdonIndent(30)
    }
    return() => {
        window.removeEventListener('resize', updateDimension)
    }
  }, [])

  return (
    <View style={{width: width - 10, height: 500 , borderWidth:2, borderColor: '#707070', borderRadius:10, padding:20}}>
        <View style={{flexDirection:'row', width: '100%', height:430}}>

            <View style={{width:'20%', height:530, alignItems:'center'}}>
                <Text>ACTIVITIES</Text>
                <View style={{flexDirection:'column', width: '95%%', justifyContent:'space-evenly', height:450}}>
                
                    <View style={{width:'100%', height:50, borderRadius: 10, borderWidth:0 , padding: 15, alignItems:'center', backgroundColor:boxActivity0}}><TouchableOpacity onPress={() => {ClickedActivites(1,0,0,0,0,0,0)}}><Text>Island Hopping</Text></TouchableOpacity></View>
                    <View style={{width:'100%', height:50, borderRadius: 10, borderWidth:0 , padding: 15, alignItems:'center', backgroundColor:boxActivity1}}><TouchableOpacity onPress={() => {ClickedActivites(0,1,0,0,0,0,0)}}><Text>Aquanaut</Text></TouchableOpacity></View>
                    <View style={{width:'100%', height:50, borderRadius: 10, borderWidth:0 , padding: 15, alignItems:'center', backgroundColor:boxActivity2}}><TouchableOpacity onPress={() => {ClickedActivites(0,0,1,0,0,0,0)}}><Text>Paraw Sailing</Text></TouchableOpacity></View>
                    <View style={{width:'100%', height:50, borderRadius: 10, borderWidth:0 , padding: 15, alignItems:'center', backgroundColor:boxActivity3}}><TouchableOpacity onPress={() => {ClickedActivites(0,0,0,1,0,0,0)}}><Text>Banana Boat</Text></TouchableOpacity></View>
                    <View style={{width:'100%', height:50, borderRadius: 10, borderWidth:0 , padding: 15, alignItems:'center', backgroundColor:boxActivity4}}><TouchableOpacity onPress={() => {ClickedActivites(0,0,0,0,1,0,0)}}><Text>Fly Fish</Text></TouchableOpacity></View>
                    <View style={{width:'100%', height:50, borderRadius: 10, borderWidth:0 , padding: 15, alignItems:'center', backgroundColor:boxActivity5}}><TouchableOpacity onPress={() => {ClickedActivites(0,0,0,0,0,1,0)}}><Text>Speed Boat</Text></TouchableOpacity></View>
                    <View style={{width:'100%', height:50, borderRadius: 10, borderWidth:0 , padding: 15, alignItems:'center', backgroundColor:boxActivity6}}><TouchableOpacity onPress={() => {ClickedActivites(0,0,0,0,0,0,1)}}><Text>Jetski</Text></TouchableOpacity></View>
                </View>
            </View>

            <View style={{width: '80%', height: 470, marginTop: -5, borderWidth:2, marginLeft:10,  borderColor: '#707070', borderRadius:10}}>

            </View>

        </View>
    </View>
  )
}